import { ROUTES, STRINGS } from '@/shared/config'
import {
  ContentWrapper,
  EmptyContent,
  HeaderContent,
  HidingSpin,
} from '@/shared/ui'
import { SearchOutlined } from '@ant-design/icons'
import { Flex, Input, Space, Typography } from 'antd'
import { useUnit } from 'effector-react'
import { useNavigate } from 'react-router-dom'

import {
  $donationsByDateTableSearchInputValue,
  DonationsByDateTableGate,
  donationsByDateTableQuery,
  donationsByDateTableSearchChanged,
} from './model/donations-by-date-table.model'
import styles from './styles.module.scss'
import { DonationsByDateTable } from './ui/DonationsByDateTable'

export function DonationsByDateListPage() {
  const { data, pending, error } = useUnit(donationsByDateTableQuery)
  const search = useUnit($donationsByDateTableSearchInputValue)
  const changeSearch = useUnit(donationsByDateTableSearchChanged)
  const navigate = useNavigate()

  return (
    <>
      <DonationsByDateTableGate />

      <HeaderContent
        title="Эквайринг"
        description="Раздел позволяет управлять платежами пользоваталей"
      />
      <ContentWrapper>
        <Flex
          className={styles.contentHeaderWrapper}
          justify="space-between"
          align="center"
        >
          <Typography.Text className={styles.contentHeader}>
            Список пожертвований
          </Typography.Text>
          <Space>
            <Input
              placeholder="Поиск по пользователям"
              allowClear
              addonAfter={<SearchOutlined />}
              value={search || ''}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const searchString = event.target.value
                changeSearch(searchString)
              }}
              className={styles.searchInput}
            />
          </Space>
        </Flex>
        <HidingSpin spinning={pending || (!data?.items && !error)}>
          {data?.items && data.items.length > 0 ? (
            <DonationsByDateTable
              onDetails={(userId) => {
                if (!userId) return
                void navigate(ROUTES.DONATIONS.USER.replace(':id', userId))
              }}
            />
          ) : search?.length && search?.length > 0 ? (
            <EmptyContent description={STRINGS.nothing_was_found} />
          ) : (
            <EmptyContent description="В списке пока нет ни одного пожертвования" />
          )}
        </HidingSpin>
      </ContentWrapper>
    </>
  )
}
